import { showSuccessToast } from '@fff-web/fff-ui-shared';
import { apiRequest, postReplenishmentSubscriptions } from '../utils/data';
import env from '../utils/env';

const REPLENISHMENT = {
  FETCH_REPLENISHMENT_PRODUCTS_REQUEST: 'replenishment/fetch_replenishment_products_request',
  FETCH_REPLENISHMENT_PRODUCTS_SUCCESS: 'replenishment/fetch_replenishment_products_success',
  FETCH_REPLENISHMENT_PRODUCTS_FAILURE: 'replenishment/fetch_replenishment_products_failure',
  SELECT_REPLENISHMENT_PRODUCT_DETAIL: 'replenishment/select_replenishment_product_detail',
  UNSELECT_REPLENISHMENT_PRODUCT_DETAIL: 'replenishment/unselect_replenishment_product_detail',
  REMOVE_VARIANT_SUBSCRIPTION: 'replenishment/remove_variant_subscription',
  OPEN_PRODUCT_REPLACEMENT_MODAL: 'replenishment/open_product_replacement_modal',
  CLOSE_PRODUCT_REPLACEMENT_MODAL: 'replenishment/close_product_replacement_modal',
  UPDATE_PRODUCT_SUBSCRIPTION_QUANTITY: 'replenishment/update_product_subscription_quantity',
};

const initialState = {
  replenishmentProducts: {
    activeProductSubscriptions: {
      NINETY_DAYS: {},
      SHIP_WITH_BOX: {},
    },
    productSubscriptions: [],
    previousProductSubscriptions: [],
  },
};

// TODO: We won't need these actions once we refactor the Modal on mobile
export const openProductReplacementModal = (product) => ({
  type: REPLENISHMENT.OPEN_PRODUCT_REPLACEMENT_MODAL,
  product,
});

export const closeProductReplacementModal = () => ({
  type: REPLENISHMENT.CLOSE_PRODUCT_REPLACEMENT_MODAL,
});

export const fetchReplenishmentProductsRequest = () => ({
  type: REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_REQUEST,
});

export const fetchReplenishmentProductsSuccess = (replenishmentProducts) => ({
  type: REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_SUCCESS,
  replenishmentProducts,
});

export const fetchReplenishmentProductsFailure = (error) => ({
  type: REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_FAILURE,
  error,
});

export const selectReplenishmentProductDetail = (product) => ({
  type: REPLENISHMENT.SELECT_REPLENISHMENT_PRODUCT_DETAIL,
  product,
});

export const unselectReplenishmentProductDetail = () => ({
  type: REPLENISHMENT.UNSELECT_REPLENISHMENT_PRODUCT_DETAIL,
});

export const removeVariantSubscriptionAction = (variantId, cadenceType) => ({
  type: REPLENISHMENT.REMOVE_VARIANT_SUBSCRIPTION,
  variantId,
  cadenceType,
});

export const updateProductSubscriptionQuantity = (payload) => ({
  type: REPLENISHMENT.UPDATE_PRODUCT_SUBSCRIPTION_QUANTITY,
  payload,
});

/**
 * @deprecated This function is deprecated and will be removed in a future version.
 * Please use getUserSubscriptions from the growth module instead.
 * @returns {Promise<void>}
 */
export const getReplenishmentSubscriptions = () => async (dispatch) => {
  dispatch(fetchReplenishmentProductsRequest());
  try {
    const response = await fetch(apiRequest('GET', `${env.replenishment}/products/self`));
    if (response.status >= 300) {
      throw response.status;
    } else {
      const replenishmentProducts = await response.json();
      dispatch(fetchReplenishmentProductsSuccess(replenishmentProducts));
    }
  } catch (error) {
    dispatch(fetchReplenishmentProductsFailure(error));
  }
};

export const updateSubscriptionQuantity = (payload) => async (dispatch) => {
  const { variantId, cadenceType, quantity } = payload;
  try {
    const response = await postReplenishmentSubscriptions([
      {
        variantId,
        operation: 'UPSERT_SUBSCRIPTION',
        cadenceType,
        quantity,
      },
    ]);

    if (response.status >= 300) {
      throw response.status;
    } else {
      showSuccessToast(
        'reFills Updated',
        'Your quantity has been successfully updated to all future deliveries.',
      );
      dispatch(updateProductSubscriptionQuantity(payload));
      dispatch(getReplenishmentSubscriptions());
      return response;
    }
  } catch (error) {
    console.log(error);
  }
};

/**
 * @param variantId
 * @param cadenceType
 * @deprecated This function is deprecated and will be removed in a future version.
 * Please use cancelUserSubscription from the growth module instead.
 * @returns {Promise<void>}
 */
export const removeVariantSubscription = (variantId, cadenceType) => async (dispatch) => {
  dispatch(removeVariantSubscriptionAction(variantId, cadenceType));
  dispatch(getReplenishmentSubscriptions());
};

const replenishmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_REQUEST:
      return {
        ...state,
        isReplenishmentLoading: true,
      };

    case REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_SUCCESS:
      return {
        ...state,
        isReplenishmentLoading: false,
        replenishmentProducts: action.replenishmentProducts,
      };

    case REPLENISHMENT.FETCH_REPLENISHMENT_PRODUCTS_FAILURE:
      return {
        ...state,
        isReplenishmentLoading: false,
        error: action.error,
      };
    case REPLENISHMENT.SELECT_REPLENISHMENT_PRODUCT_DETAIL:
      return {
        ...state,
        selectedProduct: {
          ...action.product,
          nextRenewalDate:
            state.replenishmentProducts.activeProductSubscriptions[action.product.cadenceType]
              .nextRenewalDate,
        },
      };
    case REPLENISHMENT.UNSELECT_REPLENISHMENT_PRODUCT_DETAIL:
      return {
        ...state,
        selectedProduct: {},
      };
    case REPLENISHMENT.OPEN_PRODUCT_REPLACEMENT_MODAL:
      return {
        ...state,
        replacementProductData: {
          ...action.product,
        },
      };
    case REPLENISHMENT.CLOSE_PRODUCT_REPLACEMENT_MODAL:
      return {
        ...state,
        replacementProductData: {},
      };
    case REPLENISHMENT.REMOVE_VARIANT_SUBSCRIPTION:
      return {
        ...state,
        replenishmentProducts: {
          ...state.replenishmentProducts,
          activeProductSubscriptions: {
            ...state.replenishmentProducts.activeProductSubscriptions,
            [action.cadenceType]: {
              ...state.replenishmentProducts.activeProductSubscriptions[action.cadenceType],
              subscriptions: state.replenishmentProducts.activeProductSubscriptions[
                action.cadenceType
              ].subscriptions.filter((prod) => prod.subscription.variantId !== action.variantId),
            },
          },
          previousProductSubscriptions:
            state.replenishmentProducts.previousProductSubscriptions.filter(
              (prod) => prod.subscription.variantId !== action.variantId,
            ),
        },
      };
    case REPLENISHMENT.UPDATE_PRODUCT_SUBSCRIPTION_QUANTITY:
      return {
        ...state,
        replenishmentProducts: {
          ...state.replenishmentProducts,
          activeProductSubscriptions: {
            ...state.replenishmentProducts.activeProductSubscriptions,
            [action.payload.cadenceType]: {
              ...state.replenishmentProducts.activeProductSubscriptions[action.payload.cadenceType],
              subscriptions: state.replenishmentProducts.activeProductSubscriptions[
                action.payload.cadenceType
              ].subscriptions.map((subscription) => {
                if (subscription.subscription.variantId === action.payload.variantId) {
                  return {
                    ...subscription,
                    subscription: {
                      ...subscription.subscription,
                      quantity: action.payload.quantity,
                    },
                  };
                }
                return subscription;
              }),
            },
          },
          previousProductSubscriptions:
            state.replenishmentProducts.previousProductSubscriptions.map((product) => {
              if (product.subscription.variantId === action.payload.variantId) {
                return {
                  ...product,
                  subscription: {
                    ...product.subscription,
                    quantity: action.payload.quantity,
                  },
                };
              }
              return product;
            }),
        },
      };
    default:
      return state;
  }
};

export default replenishmentReducer;
